import { IApiResponse } from "../../../@types/api-response.type";
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { ICustomField } from "../../../@types/customField.type";
import { getErrorMessage } from "../../../utils/utils";

export const getAllCustomersCustomField = async () => {

  try {
    const { data } = await Api.get(`/api/CustomerCustomField/GetAllCustomerCustomField`)
    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Campos'))
  }
}


export const getCustomerCustomFieldById = async (id: string): Promise<IApiResponse<ICustomField> | ApiException> => {

  try {
    const { data } = await Api.get<IApiResponse<ICustomField>>(`/api/CustomerCustomField/GetCustomerCustomFieldById?id=${id}`)
    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar o campo'))
  }
}

export const addOrUpdateCustomerCustomField = async (customerCustomField: ICustomField) => {
  try {
    const { data } = await Api.post('/api/CustomerCustomField/AddOrUpdateCustomerCustomField', customerCustomField);
    return data;

  } catch (error) {
    const message = 'Erro ao criar ou atualizar campo do Cliente';
    throw new ApiException(getErrorMessage(error, message));
  }
}


export const deleteCustomerCustomField = async (id: string) => {

  try {
    await Api.delete(`/api/CustomerCustomField/DeleteCustomerCustomField/${id}`);
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao deletar o campo'))
  }
}
